import { createContext, useContext, useEffect, useRef } from 'react';
import { isEmptyInputValue } from '../services/prehydration-values';
import { useFieldPropsV2 } from './field-props-context';
export const PrehydrationValuesContext = /*#__PURE__*/ createContext(undefined);
const readText = (element)=>element.value;
export const useKeepPrehydrationValue = (ref)=>{
    const registry = useContext(PrehydrationValuesContext);
    const { path, value, readPrehydrationValue = readText } = useFieldPropsV2();
    const mountedFieldRef = useRef({
        path,
        value,
        registry,
        read: readPrehydrationValue
    });
    useEffect(()=>{
        const field = mountedFieldRef.current;
        const domValue = ref.current ? field.read(ref.current) : undefined;
        if (field.registry && !isEmptyInputValue(domValue) && isEmptyInputValue(field.value)) {
            field.registry.current.set(field.path, domValue);
        }
    }, [
        ref
    ]);
};

//# sourceMappingURL=prehydration-values-context.js.map